import { inject, Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { tap } from "rxjs";
import * as ClassroomEvents from "../../public/classroom-events.actions";
import { ClassroomFacade } from "../../public/yjs/classroom.facade";

/**
 * Owns the Y.Doc write for the same-slide reset gesture.
 *
 * The gesture is announced ONCE via `ClassroomEvents.userResetActiveSlide`
 * (dispatched by the teacher workspace effects on a same-slide re-click). This
 * effect translates it into the primary-layer reset write. Other features
 * (toolbar tool reset, driverscam stop, preview-screen layer-2 / append
 * cleanup, workspace reducer cleanup) react to the same action independently;
 * the canvas reset reacts to the resulting Y.Doc cleared$ events, not the action.
 *
 * Reacting off the action rather than writing inline at the dispatch site is
 * safe: no listener depends on the reset Y.Doc fields being written first. See
 * references/state-write-vs-event-dispatch.md (#1) and reset-dynamic-content.md.
 */
@Injectable()
export class ClassroomResetEffects {
    private readonly actions$ = inject(Actions);
    private readonly classroom = inject(ClassroomFacade);

    readonly writeResetToYjs$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(ClassroomEvents.userResetActiveSlide),
                tap(() => this.classroom.resetSlideToInitial(1)),
            ),
        { dispatch: false },
    );
}
